// START: GitHub Copilot Generated Code
import config from "../config/config";

/**
 * Logs a debug message unless the environment is PRD.
 * Intentionally kept in a standalone file with no store dependency so that
 * Redux slices and middleware can import it without creating circular references.
 */
export const LogVerbose = (msg: string, fmt?: unknown) => {
    if (config.env === 'PRD')
        return;
    console.debug(`%c${msg}`, fmt);
};
// END: GitHub Copilot Generated Code
